/* istanbul ignore file */
import { connect } from 'react-redux'

import StepThreeData from './StepThreeData'
import { bookingDataSelector } from 'rental-car-contract/js/selectors/booking'
function mapStateToProps (state) {
    const booking = bookingDataSelector(state)
    return {
        extras: booking.extras || [],
        fixedCoverages: booking.fixedCoverages || [],
    }
}

export default connect(mapStateToProps, null)(StepThreeData)
